var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.isLoading
        ? _c("loader")
        : _vm.isDisabled
        ? [
            _c("div", { staticClass: "input disabled" }, [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.selectedValue
                      ? _vm.selectedValue.countryTranslation
                      : ""
                  ) +
                  "\n        "
              ),
            ]),
          ]
        : [
            _c("div", { staticClass: "control is-expanded" }, [
              _c("span", { staticClass: "select is-fullwidth" }, [
                _c(
                  "select",
                  {
                    attrs: { disabled: _vm.isDisabled },
                    domProps: { value: _vm.value },
                    on: { input: _vm.onChange },
                  },
                  [
                    _vm.value == null
                      ? _c(
                          "option",
                          {
                            attrs: { disabled: "", hidden: "" },
                            domProps: { value: null },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("choose")) +
                                "\n                    "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.options, function (option, key) {
                      return _c(
                        "option",
                        { key: key, domProps: { value: option.alpha2Code } },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(option.countryTranslation) +
                              "\n                    "
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ]),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }